// extracted by mini-css-extract-plugin
export var modalInnerStyle = "modal_card-module--modalInnerStyle--RJJdH";